import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col,
} from "reactstrap";

// Core components
import { Link } from "react-router-dom";

export default function EventCarouselItem({ img, caption, description, id, name, category, events }) {
  return (
    <div
      className="page-header flex-centered section-dark"
      style={{ backgroundImage: `url('${img}')` }}
    >
      <div className="filter" style={{ opacity: 0.2 }} />
      <div className="content-center">
        <Container style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.4) 100%)`, borderRadius: "10px", maxWidth: "80%" }}>
          <Row>
            <Link to={{ pathname: `/portfolio/${id}/${name}`, state: { category, events } }}
              style={{ minWidth: "100%", color: "inherit" }}
            >
              <Col className="ml-auto mr-auto text-center" md="8">
                <h1 className="title" style={{ fontSize: "5vh" }}><b>{caption}</b></h1>
                <h5>
                  <b>
                    {description}
                  </b>
                </h5>
                <br />
              </Col>
            </Link>
          </Row>
        </Container>
      </div>
    </div>
  )
};